<template>
  <div class="view-pg oopt-view">
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ oopt.transName }}</h1>
      <div class="view-head">
        <v-tabs
          left
        >
          <v-tab>{{ $t('Основные сведения') }}</v-tab>
          <v-tab-item>
            <div class="view-description">
              <div class="view-main-info">
                <!-- Паспорт -->
                <div class="main-info-item">
                  <h5>
                    {{ $t('Паспорт') }}
                    <template v-if="oopt.type">
                      <span v-if="oopt.type.id !== oopt.typeIdConst"> - {{ oopt.type.transName }}</span>
                    </template>
                  </h5>
                  <p>
                    {{ $t('Полное наименование') }}:
                    <span v-if="oopt.transLegalFormName">{{ oopt.transLegalFormName }} </span>
                    <span>"{{ oopt.transName }}"</span>
                  </p>
                  <p>
                    <label>
                      {{ $t('ИНН') }}:
                      <span v-if="oopt.inn">{{ oopt.inn }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                    <label>
                      {{ $t('ОКПО') }}:
                      <span v-if="oopt.okpo">{{ oopt.okpo }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Территория по СОАТЕ') }}:
                      <span v-for="item in oopt.soateTerritories" :key="item.id">
                        {{ item.transName }}
                      </span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Месторасположение') }}:
                      <label v-html="oopt.transGeoLocation"></label>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('ФИО руководителя') }}:
                      <span v-if="oopt.transHeadFullName">{{ oopt.transHeadFullName }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Должность руководителя') }}:
                      <span v-if="oopt.transHeadPosition">{{ oopt.transHeadPosition }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Юридический адрес') }}:
                      <span v-if="oopt.locality">
                        {{ oopt.locality.treeFullTransName }}
                      </span>
                      <span>{{ oopt.transLegalAddress }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      {{ $t('Телефон') }}:
                      <span v-if="oopt.phones">{{ oopt.phones }}</span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      Email:
                      <span v-if="oopt.email"><a v-bind:href="'mailto:' + oopt.email">{{ oopt.email }}</a></span>
                      <span v-else>{{ $t('Нет сведений') }}</span>
                    </label>
                  </p>
                  <p v-if="oopt.founders">
                    <label>
                      {{ $t('Учредители') }}:
                      <span>{{ oopt.founders }}</span>
                    </label>
                  </p>
                </div>
                <div class="main-info-item">
                  <h5>{{ $t('Карта участка') }}</h5>
                  <MapOpenLayerItems :ooptId="$route.params.id"/>
                </div>
                <div class="main-info-item">
                  <FaunaSummaryReport :years="years" ref="faunaSummaryReport"
                                      :title="$t('Данные о численности животных в угодьях')"/>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-container>
  </div>
</template>
<script>
import OOPT from '@/model/oopt'
import { mapMutations } from 'vuex'
import FaunaSummaryReport from '@/components/app/FaunaSummaryReport'
import MapOpenLayerItems from '@/components/oopt/MapOpenLayerItems'

export default {
  components: {
    FaunaSummaryReport,
    MapOpenLayerItems
  },
  data: () => ({
    oopt: {},
    years: [],
    showMore: false,
    breadcrumbs: [],
    backUrl: process.env.VUE_APP_BACK_URL
  }),
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // Данные ООПТ
    fetchData () {
      this.setLoading(true)
      OOPT.getOoptView(this.$route.params.id)
        .then((response) => {
          if (response.status === 400) {
            this.$router.push({
              name: 'Search'
            })
          }
          this.oopt = response.data.oopt
          this.years = response.data.years

          this.$refs.faunaSummaryReport.fetchData({ ooptId: this.oopt.id })

          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: '/'
            },
            {
              text: this.$i18n.t('Организации'),
              disabled: false,
              href: '/search-organizations'
            },
            {
              text: this.oopt.transName,
              disabled: true
            }
          ]
          this.scrollToTop()
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.$router.push({
            name: 'search-organizations'
          })
        })
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
